import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo recibo el libro?',
    a: 'Inmediatamente después de tu compra recibirás un correo electrónico con el enlace de descarga para acceder a todo el material.'
  }, {
    q: '¿Necesito experiencia en repostería?',
    a: 'No, las recetas están explicadas paso a paso desde cero, pensadas especialmente para principiantes.'
  }, {
    q: '¿Puedo verlo en mi celular?',
    a: 'Sí, el libro es en formato PDF de alta calidad, compatible con cualquier celular, tablet o computadora.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 45 días de garantía total. Si no estás satisfecho con las recetas, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No, los 4 bonos están incluidos totalmente gratis con tu compra de hoy.'
  }, {
    q: '¿Puedo usar las recetas para vender?',
    a: '¡Sí! Incluso incluimos un bono especial para ayudarte a empezar a vender budines caseros y calcular tus precios.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#FEF3E2]" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#3D2B1F]" data-id="element-56">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E8D5C4] rounded-xl overflow-hidden transition-all duration-300 shadow-sm" data-id="element-58">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-59">
                <span className="font-bold text-lg text-[#3D2B1F] pr-4" data-id="element-60">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#D4850A] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-61" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                <p className="text-[#6B5344] text-lg" data-id="element-63">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}